import { Component, ViewContainerRef, OnInit, ViewEncapsulation, EventEmitter, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/field-config.interface';
import { MatFormField, MatLabel, MatInput, MatHint, MatError } from '@angular/material/input';
import { NgClass } from '@angular/common';
import { IosMinusButtonDirective } from '../../../directives/ios-minus-button.directive';
import { NumberOnlyDirective } from '../../../directives/num-only.directive';
import { DecimalConverterDirective } from '../../../directives/decimal-converter.directive';
import { BlockPasteDirective } from '../../../directives/block-paste.directive';
import { DigitOnlyDirective } from '../../../directives/digit-only.directive';

@Component({
    selector: 'app-form-input',
    templateUrl: './form-input.component.html',
    styleUrls: ['form-input.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [ReactiveFormsModule, MatFormField, NgClass, MatLabel, MatInput, IosMinusButtonDirective, NumberOnlyDirective, DecimalConverterDirective, BlockPasteDirective, MatHint, MatError, DigitOnlyDirective]
})
export class FormInputComponent implements Field, OnInit {
  @Output() valueChange: EventEmitter<any> = new EventEmitter();

  public FormControlName;
  config: FieldConfig;
  group: FormGroup;
  onlyNumber: any;
  digitOnly: any;
  numbersDotOnly: any;
  isNegativeNumberAllowed: boolean = true;
  inputEmiter() {
    /*  */
    this.valueChange.emit('test');
  }

  ngOnInit() {
   this.FormControlName = this.config.name;
   this.onlyNumber = this.config.directive &&  this.config.directive === 'numberOnly';
   this.digitOnly = this.config.directive &&  this.config.directive === 'digitOnly';
   this.numbersDotOnly = this.config.directive &&  this.config.directive === 'numbersDotOnly';
   this.isNegativeNumberAllowed = this.config.hasOwnProperty('isNegativeNumberAllowed') ? this.config?.isNegativeNumberAllowed : true;
  }

  onInputChange(event: any) {
    const value = event?.target?.value || '';
    if (this.onlyNumber && !this.isNegativeNumberAllowed) {
      let cleanValue = value.replace(/-/g, '');
      const dynamicRegex = this.generateDynamicRegex();
      cleanValue = !dynamicRegex.test(cleanValue) ? '' : cleanValue;
      this.group.controls[this.FormControlName].setValue(cleanValue, { emitEvent: false });
    }
    this.valueChange.emit(this.group.controls[this.FormControlName].value);
  }

  generateDynamicRegex(): RegExp {
    return new RegExp("-?([0-9]{1,10}([.][0-9]{0,6})?)");
  }

}
